/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_FieldInputs */

const vi_camera_attach_field = /** @type {(inputs: Camera_Attach_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

/**

* @param {Camera_Attach_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_field = /** @type {((inputs?: Camera_Attach_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_field(inputs)
});